





















































import { Component, Vue, Prop } from 'vue-property-decorator';

import {
  IInternationalization,
  IInternationalizationStatus
} from '@/models/internationalization';
import { getCountryFlagFile } from '@/constants/countryFlags';

import { Typography, Picture } from '@/components/atoms';
import CloseIcon from '@/components/icons/Close.vue';

type TagInfo = {
  bg: string;
  color: string;
  label: string;
};

type CountrySelectVariant = 'default' | 'v2';

export enum BgByStatus {
  FULL = '#D0F9E6',
  BETA = '', // TODO: Set color
  COMING_SOON = '#FFECD4',
  ONLINE_ONLY = '#D9ECFF',
  UNDATED = '#FFECD4'
}

export enum ColorByStatus {
  FULL = '#105A40',
  BETA = '',
  COMING_SOON = '#8A3200',
  ONLINE_ONLY = '#0044B2',
  UNDATED = '#8A3200'
}

@Component({
  components: {
    Typography,
    Picture,
    CloseIcon
  }
})
export default class CountryItem extends Vue {
  @Prop({ required: true }) readonly country?: IInternationalization;
  @Prop({ default: false }) readonly showCloseButton?: boolean;
  @Prop({ default: false }) readonly isActive?: boolean;
  @Prop({ default: 'default' }) readonly variant?: CountrySelectVariant;
  @Prop({ default: true }) showCurrencySymbol?: boolean;
  @Prop({ default: true }) showTag?: boolean;

  get tPrefix() {
    return 'common.components.countryItem';
  }

  get tagInfoByStatus(): Record<IInternationalizationStatus, TagInfo> {
    return {
      full: {
        bg: BgByStatus.FULL,
        color: ColorByStatus.FULL,
        label: String(this.$t(`${this.tPrefix}.status.full`))
      },
      beta: {
        bg: BgByStatus.BETA,
        color: ColorByStatus.BETA,
        label: String(this.$t(`${this.tPrefix}.status.beta`))
      },
      online_only: {
        bg: BgByStatus.ONLINE_ONLY,
        color: ColorByStatus.ONLINE_ONLY,
        label: String(this.$t(`${this.tPrefix}.status.online_only`))
      },
      coming_soon: {
        bg: BgByStatus.COMING_SOON,
        color: ColorByStatus.COMING_SOON,
        label: String(this.$t(`${this.tPrefix}.status.coming_soon`))
      },
      undated: {
        bg: BgByStatus.UNDATED,
        color: ColorByStatus.UNDATED,
        label: String(this.$t(`${this.tPrefix}.status.undated`))
      }
    };
  }

  get hasCountry() {
    return !!Object.keys(this.country || {}).length;
  }

  get countryFlagFile() {
    return getCountryFlagFile(this.country && this.country.countryIso2);
  }
}
